import type { ReactNode, ElementType } from 'react';
import { cn } from '@shared/lib/utils';

interface EmptyStateProps {
  icon?: ElementType;
  title: string;
  description?: string;
  action?: ReactNode;
  /** 'default' = bordered dashed, 'minimal' = no border */
  variant?: 'default' | 'minimal';
  className?: string;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  variant = 'default',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-4 text-center',
        variant === 'default' &&
          'rounded-xl border border-dashed bg-muted/20 px-6 py-16',
        variant === 'minimal' && 'py-12',
        className,
      )}
    >
      {Icon && (
        <div className="relative">
          {/* Outer ring */}
          <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-muted/80">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-background shadow-sm ring-1 ring-border">
              <Icon className="h-5 w-5 text-muted-foreground" />
            </div>
          </div>
        </div>
      )}

      <div className="space-y-1.5 max-w-xs">
        <p className="text-sm font-semibold text-foreground">{title}</p>
        {description && (
          <p className="text-xs leading-relaxed text-muted-foreground">{description}</p>
        )}
      </div>

      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
